import type { NodeProps } from '@xyflow/react';
import type { PipelineNode } from '../types/canvas.types';

function areObjectsShallowEqual(
  left: Record<string, unknown>,
  right: Record<string, unknown>
): boolean {
  const leftKeys = Object.keys(left);
  const rightKeys = Object.keys(right);

  if (leftKeys.length !== rightKeys.length) {
    return false;
  }

  for (const key of leftKeys) {
    if (!Object.is(left[key], right[key])) {
      return false;
    }
  }

  return true;
}

export function areNodePropsEqual<T extends PipelineNode>(
  prev: NodeProps<T>,
  next: NodeProps<T>
): boolean {
  // Intentionally ignore `dragging` (and position, handled by React Flow's wrapper):
  // custom nodes don't read `dragging`, and toggling it forced extra renders during drag.
  if (
    prev.id !== next.id ||
    prev.type !== next.type ||
    prev.selected !== next.selected ||
    prev.zIndex !== next.zIndex ||
    prev.isConnectable !== next.isConnectable
  ) {
    return false;
  }

  return areObjectsShallowEqual(
    prev.data as Record<string, unknown>,
    next.data as Record<string, unknown>
  );
}
